import * as React from 'react';
import { formatCondensedHumanDate, formatShortHumanMonth } from '~/DateTime';
import { calculateYearPeriod } from '~/ExchangeRate/calculateYearPeriod';
import { calculateYearQuarter } from '~/ExchangeRate/calculateYearQuarter';

export enum TimePeriod {
	daily = 'daily',
	fixed = 'fixed',
	previous12MonthsAvg = 'previous-12-months-avg',
	previousQuarterAvg = 'previous-quarter-avg',
}

interface RateTimePeriodProps {
	date: Date;
	timePeriod: TimePeriod;
	fromLabel?: string;
	averageLabel?: string;
}

export function RateTimePeriod({
	date,
	timePeriod,
	fromLabel = 'From',
	averageLabel = 'Average',
}: RateTimePeriodProps) {
	switch (timePeriod) {
		case TimePeriod.daily:
		case TimePeriod.fixed:
			return (
				<>
					{fromLabel} {formatCondensedHumanDate(date)}
				</>
			);

		case TimePeriod.previous12MonthsAvg: {
			const [fromDate, toDate] = calculateYearPeriod(date);
			return (
				<>
					{averageLabel} of {formatShortHumanMonth(fromDate)}-{formatShortHumanMonth(toDate)}
				</>
			);
		}

		case TimePeriod.previousQuarterAvg: {
			const [year, quarter] = calculateYearQuarter(date);
			return (
				<>
					{averageLabel} of {year} Q{quarter}
				</>
			);
		}

		default:
			return <></>;
	}
}
